(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["balanz-nuestro-cafe"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('balanz-coffee-story')) {
  customElements.define('balanz-coffee-story', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        this.readyHandler = () => this.initialize();
        document.addEventListener('DOMContentLoaded', this.readyHandler, {once:true});
      } else this.initialize();
    }
    initialize() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.picked = null; this.hovered = null; this.focused = null;
      this.bar = this.querySelector('.balance-bar');
      this.star = this.querySelector('.star-icon');
      this.bowls = [...this.querySelectorAll('.bowl')];
      if (!this.bar || !this.star || !this.bowls.length) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const disabled = () => this.motion.matches || this.dataset.motion === 'false';
      const reveal = () => { this.classList.remove('is-waiting'); this.classList.add('is-running'); };
      if (!disabled() && 'IntersectionObserver' in window) {
        this.classList.add('is-waiting');
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) reveal();
            else this.classList.remove('is-running');
          });
        }, {threshold: 0.05});
        this.observer.observe(this);
      } else reveal();
      this.motion.addEventListener('change', () => { if(disabled()) reveal(); this.render(); }, {signal});
      this.bowls.forEach(el => {
        const id = el.dataset.id;
        el.addEventListener('click', () => {
          this.picked = this.picked === id ? null : id;
          this.render();
          this.querySelector('[data-status]').textContent = this.picked ? 'Perfil seleccionado: ' + el.getAttribute('aria-label') : 'Selección borrada.';
          if (this.picked && !disabled()) {
            this.star.getAnimations().forEach(animation => animation.cancel());
            this.star.animate([{transform:'scale(1)'},{transform:'scale(1.2) rotate(12deg)'},{transform:'scale(1)'}],{duration:700,easing:'ease-out'});
          }
        }, {signal});
        el.addEventListener('pointerenter', e => { if(e.pointerType === 'mouse') { this.hovered = id; this.render(); } }, {signal});
        el.addEventListener('pointerleave', () => { this.hovered = null; this.render(); }, {signal});
        el.addEventListener('focus', () => { this.focused = id; this.render(); }, {signal});
        el.addEventListener('blur', () => { this.focused = null; this.render(); }, {signal});
        el.addEventListener('keydown', e => { if(e.key === 'Escape') { this.picked = null; this.querySelector('[data-status]').textContent = 'Selección borrada.'; this.render(); } }, {signal});
      });
      this.classList.add('is-initialized');
      this.render();
    }
    render() {
      const active = this.hovered || this.focused || this.picked;
      const tilts = {suave:-9,equi:0,carac:9};
      this.bar.style.animation = active ? 'none' : '';
      this.bar.style.transform = 'rotate(' + (active ? tilts[active] : 0) + 'deg)';
      this.bowls.forEach(el => {
        const selected = el.dataset.id === this.picked;
        const dim = this.picked !== null && !selected;
        const lift = el.querySelector('.lift');
        const chip = el.querySelector('.chip');
        el.classList.toggle('is-preview', el.dataset.id === this.hovered || el.dataset.id === this.focused);
        lift.style.transform = selected ? 'translate(-3px,-9px) scale(1.075)' : 'none';
        lift.style.filter = selected ? 'drop-shadow(-16px 16px 0 rgba(28,34,31,.3))' : dim ? 'brightness(.8) saturate(.7)' : 'none';
        chip.style.background = selected ? '#175D50' : 'rgba(244,245,241,.94)';
        chip.style.color = selected ? '#D9FF7A' : '#175D50';
        el.setAttribute('aria-pressed', String(selected));
      });
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.readyHandler);
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect();
      this.star?.getAnimations().forEach(animation => animation.cancel());
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
